import { Component, Input, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-fly-out-component',
  templateUrl: './fly-out-component.component.html',
  styleUrls: ['./fly-out-component.component.scss']
})
export class FlyOutComponentComponent implements OnInit {

  @Input() data: any;

  deviceProperties: Array<DeviceProperties> = [];
  constructor(private translocoService: TranslocoService,) { }
  ngOnInit(): void {
    this.prepareDevicePropties();
  }
  prepareDevicePropties() {
    if (this.data?.registerStatus.toLowerCase() == "Pre-Registered".toLowerCase()) {
      this.deviceProperties.push({
        key: this.translocoService.translate('Remote Service feature is not enabled for this asset'),
        value: ''
      } as DeviceProperties);
    }
    else {
      this.deviceProperties.push({
        key: 'rsaVersionText',
        value: this.data.rsaVersion
      } as DeviceProperties);
      if (this.data.softwareVersion != null && this.data.softwareVersion != '0.0.0' && this.data.softwareVersion != "") {
        this.deviceProperties.push({
          key: 'softwareVersion',
          value: this.data.softwareVersion
        } as DeviceProperties);
      }
    }
  }

}

export interface DeviceProperties {
  key: string;
  value: string;
}